export default __webpack_public_path__ + "static/media/service_intro.1fdda236.mp4";